import { render } from "./ListGroupComponent.vue?vue&type=template&id=2b52dab5"
import script from "./ListGroupComponent.vue?vue&type=script&lang=js"
export * from "./ListGroupComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__